const LOGISTICS = {
  permission: {
    'logistics': {
      view: true
    },
    'logistics_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}
const MFG = {
  permission: {
    'mfg': {
      view: true
    },
    'mfg_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}

const ACCT = {
  permission: {
    'acct': {
      view: true
    },
    'acct_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}

const FF = {
  permission: {
    'ff': {
      view: true
    },
    'ff_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}
const BT = {
  permission: {
    'bt': {
      view: true
    },
    'bt_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}

const GT = {
  permission: {
    'gt': {
      view: true
    },
    'gt_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}

const TB = {
  permission: {
    'tb': {
      view: true
    },
    'tb_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}
const SE = {
  permission: {
    'se': {
      view: true
    },
    'se_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}
// Master data
const CUSTOMER = {
  permission: {
    'tb': {
      view: true
    },
    'tb_read': {
      view: true
    },
    'gt': {
      view: true
    },
    'gt_read': {
      view: true
    },
    'ff': {
      view: true
    },
    'ff_read': {
      view: true
    },
    'se': {
      view: true
    },
    'se_read': {
      view: true
    },
    'bt': {
      view: true
    },
    'bt_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}

const CUSTOMER_DETAIL = {
  permission: {
    'tb': {
      view: true
    },
    'tb_read': {
      view: true
    },
    'gt': {
      view: true
    },
    'gt_read': {
      view: true
    },
    'ff': {
      view: true
    },
    'ff_read': {
      view: true
    },
    'se': {
      view: true
    },
    'se_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    },
    acct: {
      view: true
    },
    acct_read: {
      view: true
    },
    logistics: {
      view: true
    },
    logistics_read: {
      view: true
    }
  }
}
const COST = {
  permission: {
    'acct': {
      view: true
    },
    'acct_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}
const PORT = {
  permission: {
    'logistics': {
      view: true
    },
    'logistics_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}

const PLAN = {
  permission: {
    'plan': {
      view: true
    },
    'plan_read': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}

const HR = {
  permission: {
    'hr': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}

const IR = {
  permission: {
    'ir': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}

const AGRI = {
  permission: {
    'agri': {
      view: true
    },
    'bom': {
      view: true
    },
    'admin': {
      view: true
    }
  }
}


export default {
  IR,
  HR,
  LOGISTICS,
  MFG,
  ACCT,
  FF,
  SE,
  GT,
  TB,
  CUSTOMER,
  CUSTOMER_DETAIL,
  COST,
  PORT,
  PLAN,
  BT,
  AGRI
}